import React, { useState } from 'react';
import { useEffect } from 'react';
//import { Fancybox } from "@fancyapps/ui";
import { Map } from "@/components/shared/Map";
import { lmAddCommas, lmFormatAddress, lmParse, mlsFormatDetail, mlsFormatDetailList } from '@/utils/helpers';
import { lmMLSListing } from '@/utils/api';
import { MLSListing } from '@/utils/types/MLSListing';
import { Address } from '@/utils/types/Address';
import { MLSMember } from '@/utils/types/MLSMember';
import { MLSMedia } from '@/utils/types/MLSMedia';
import '@/styles/components/mls-listings.scss';
import '@/styles/components/mls-listing.scss';
//import RenderForm from '../shared/RenderForm';

import LightGallery from 'lightgallery/react';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';

const Listing: React.FC<{ listingID: string }> = ({ listingID }) => {
    const [ listing, setListing ] = useState<MLSListing | undefined>( undefined );

    const status_map: Record<string, string> = {
        S: 'For Sale',
        R: 'For Rent',
    }
    
    useEffect( () => {
        async function fetchData() {
            await lmMLSListing( parseInt( listingID ? listingID : '', 10 ) ).then( ( data: MLSListing ) => {
                if ( data ) {
                    setListing( data as MLSListing );
                } 
            } );
        }
        fetchData();
    }, [ listingID ] );  
    
    // useEffect(() => {
    //     if (listing) {
    //         Fancybox.unbind('[data-fancybox]');
    //         setTimeout(() => {
    //             Fancybox.bind('[data-fancybox]', {
    //                 closeButton: true,
    //                 delegate: document.querySelector('[data-fancybox]') as HTMLElement, 
    //             });
    //         }, 0);
    //     }

    //     return () => {
    //         Fancybox.unbind('[data-fancybox]');
    //     };
    // }, [listing]);
    
    if ( listing ) {
                               
        const price: string = lmAddCommas( Number( listing.Price ) );
        const status: string = status_map[ listing.SaleRent ] ? status_map[ listing.SaleRent ] : '';
        const address: string = lmFormatAddress( {
            address1: listing.Address,
            city: listing.City,
            state: listing.State,
            zip: listing.Zip,
        } as Address );
        const mapAddress: string = lmFormatAddress( {
            address1: listing.Address,
            city: listing.City,
            state: listing.State,
            zip: listing.Zip,
        } );
        const sqft = Number( listing.AboveArea ) > 0 ? lmAddCommas( Number( listing.AboveArea ) ) : '';
        const baths: string = listing.FullBaths + ( listing.HalfBaths && Number( listing.HalfBaths ) > 0 ? '+' : '' );
        const member: MLSMember = listing.member;
        const appliances: Array<string> = [
            'ApOven',
            'ApFridge',
            'ApDishwasher',
            'ApMicrowave',
            'ApDisposal',
            'ApWasher',
            'ApDryer',
            'ApHotWaterHeater',
        ];
        const exteriorFeatures: Array<string> = [
            'ExDeck',
            'ExPatio',
            'ExOpenPorch',
            'ExScreenPorch',
            'ExEnclosedPorch',
            'ExCoveredPorch',
        ];
        const lotFeatures: Array<string> = [
            'ExFence',
            'ExOutdoorShower',
            'ExSprinklerSystem',
            'ExGolf',
            'ExTennis',
            'ExCulDeSac',
            'ExCorner',
            'ExTrees',
            'ExDriveway',
        ];
        const siding: Array<string> = [
            'SdBrick',
            'SdVinyl',
            'SdWood',
            'SdT111',
            'SdAluminum',
            'SdCement',
            'SdAsbestos',
            'SdHardi',
            'SdStucco',
            'SdMasonry',
            'SdLog',
            'SdCedarClapboard',
            'SdCedarShake',
            'SdStone',
        ];
        const roof: Array<string> = [
            'RfAsphalt',
            'RfSlate',
            'RfTile',
            'RfRubber',
            'RfTar',
            'RfFlat',
            'RfCedar',
            'RfMetal',
        ];

        const heroImage: MLSMedia = listing.media[0];
        const ListingMedia: React.FC = () => {
            if ( listing.media.length ) {
                return (
                    <LightGallery
                        //speed={500}
                        //plugins={[lgThumbnail, lgZoom]}
                        elementClassNames="mls-listing-images"
                    >
                    { listing.media.map( ( photo: MLSMedia, index: number ) => {
                        return (
                            <a href={ photo.PhotoUrl }
                                key={ index }
                                data-caption={ photo.Caption }>
                                <figure className="mls-listing-image-wrapper">
                                    <img src={ photo.SmallPhotoUrl.length ? photo.SmallPhotoUrl : photo.PhotoUrl } className="mls-listing-image" />
                                </figure>
                            </a>
                        );
                    } ) }
                    </LightGallery>
                );
            }
        }

        const date: Date = new Date();
        const copyrightYear: number = date.getFullYear();

        return (
            <>
            <div id="mls-listing-hero">
                <div className="mls-listing-content-summary">
                    <span className="mls-listing-price">{ price }</span>
                    <span className="mls-listing-status">{ status }</span>
                    <span className="mls-listing-address">{ lmParse( address ) }</span>
                    <ul className="mls-listing-details">
                        <li className="mls-listing-beds">
                            <span className="mls-detail-label">Beds</span>
                            <span className="mls-detail-value">{ mlsFormatDetail( listing.Beds ) }</span>
                        </li>
                        <li className="mls-listing-baths">
                            <span className="mls-detail-label">Baths</span>
                            <span className="mls-detail-value">{ mlsFormatDetail( baths ) }</span>
                        </li>
                        <li className="mls-listing-sqft">
                            <span className="mls-detail-label">Square Feet</span>
                            <span className="mls-detail-value">{ mlsFormatDetail( sqft ) }</span>
                        </li>
                        <li className="mls-listing-year">
                            <span className="mls-detail-label">Year Built</span>
                            <span className="mls-detail-value">{ mlsFormatDetail( listing.YearBuilt ) }</span>
                        </li>
                    </ul>
                </div>
                <span>
                    <figure className="mls-listing-image-wrapper">
                        <img src={ heroImage.PhotoUrl } className="mls-listing-image" />
                    </figure>
                </span>
            </div>
            { listing.PublicRemarks ?
                <div className="mls-listing-section mls-about-section">
                    <h2>About This Property</h2>
                    { lmParse( listing.PublicRemarks ) }
                </div>
            : null }
            <ListingMedia />
            <div className="mls-listing-section mls-property-info-section">
                <h2>Property Info</h2>
                <ul className="mls-listing-details">
                    <li className="mls-listing-community">
                        <span className="mls-detail-label">Community Name</span>
                        <span className="mls-detail-value">{ mlsFormatDetail( listing.CommunityName ) }</span>
                    </li>
                    <li className="mls-listing-city">
                        <span className="mls-detail-label">City</span>
                        <span className="mls-detail-value">{ mlsFormatDetail( listing.City ) }</span>
                    </li>
                    <li className="mls-listing-state">
                        <span className="mls-detail-label">State</span>
                        <span className="mls-detail-value">{ mlsFormatDetail( listing.State ) }</span>
                    </li>
                    <li className="mls-listing-zipcode">
                        <span className="mls-detail-label">Zipcode</span>
                        <span className="mls-detail-value">{ mlsFormatDetail( listing.Zip ) }</span>
                    </li>
                    <li className="mls-listing-county">
                        <span className="mls-detail-label">County</span>
                        <span className="mls-detail-value">{ mlsFormatDetail( listing.County ) }</span>
                    </li>
                    <li className="mls-listing-id">
                        <span className="mls-detail-label">Listing ID</span>
                        <span className="mls-detail-value">{ mlsFormatDetail( listing.ListingId ) }</span>
                    </li>
                </ul>
            </div>
            <div className="mls-listing-section mls-location-section">
                <h2>Location</h2>
                <Map lat={ listing.Latitude } lng={ listing.Longitude } label={ lmParse( mapAddress ) as string } />
            </div>
            <div className="mls-listing-section mls-home-details-section">
                <h2>Home Details</h2>
                <ul className="mls-listing-details">
                    <li className="mls-listing-Bedrooms">
                        <span className="mls-detail-label">Bedrooms</span>
                        <span className="mls-detail-value">{ mlsFormatDetail( listing.Beds ) }</span>
                    </li>
                    <li className="mls-listing-full-baths">
                        <span className="mls-detail-label">Full Bathrooms</span>
                        <span className="mls-detail-value">{ mlsFormatDetail( listing.FullBaths ) }</span>
                    </li>
                    <li className="mls-listing-half-baths">
                        <span className="mls-detail-label">Half Bathrooms</span>
                        <span className="mls-detail-value">{ mlsFormatDetail( listing.HalfBaths ) }</span>
                    </li>
                    <li className="mls-listing-water">
                        <span className="mls-detail-label">Water Source</span>
                        <span className="mls-detail-value">{ mlsFormatDetail( listing.WaterType ) }</span>
                    </li>
                    <li className="mls-listing-appliances">
                        <span className="mls-detail-label">Appliances</span>
                        <span className="mls-detail-value">{ mlsFormatDetailList( appliances, listing, 'Ap' ) }</span>
                    </li>
                    <li className="mls-listing-sewer">
                        <span className="mls-detail-label">Sewer</span>
                        <span className="mls-detail-value">{ mlsFormatDetail( listing.SewerType ) }</span>
                    </li>
                    <li className="mls-listing-exterior">
                        <span className="mls-detail-label">Exterior Features</span>
                        <span className="mls-detail-value">{ mlsFormatDetailList( exteriorFeatures, listing, 'Ex' ) }</span>
                    </li>
                    <li className="mls-listing-lot">
                        <span className="mls-detail-label">Lot Features</span>
                        <span className="mls-detail-value">{ mlsFormatDetailList( lotFeatures, listing, 'Ex' ) }</span>
                    </li>
                    <li className="mls-listing-siding">
                        <span className="mls-detail-label">Siding</span>
                        <span className="mls-detail-value">{ mlsFormatDetailList( siding, listing, 'Sd' ) }</span>
                    </li>
                    <li className="mls-listing-roof">
                        <span className="mls-detail-label">Roof</span>
                        <span className="mls-detail-value">{ mlsFormatDetailList( roof, listing, 'Rf' ) }</span>
                    </li>
                </ul>
            </div>
            { member ?
            <div className="mls-listing-section mls-agent-information-section">
                <h2>Agent Information</h2>
                <ul className="mls-listing-details">
                    <li className="mls-listing-agent-name">
                        <span className="mls-detail-label">Agent Name</span>
                        <span className="mls-detail-value">{ lmParse( mlsFormatDetail( `${member.Firstname} ${member.Lastname}` ) ) }</span>
                    </li>
                    <li className="mls-listing-agent-group">
                        <span className="mls-detail-label">Agency or Broker Name</span>
                        <span className="mls-detail-value">{ mlsFormatDetail( member.Company ) }</span>
                    </li>
                    <li className="mls-listing-agent-email">
                        <span className="mls-detail-label">Agent Email</span>
                        <span className="mls-detail-value">{ mlsFormatDetail( member.AccountEmail ) }</span>
                    </li>
                    <li className="mls-listing-agent-phone">
                        <span className="mls-detail-label">Agent Phone Number</span>
                        <span className="mls-detail-value">{ mlsFormatDetail( member.Bphone ) }</span>
                    </li>
                    <li className="mls-listing-agent-mlsid">
                        <span className="mls-detail-label">Listing Agent MLS ID</span>
                        <span className="mls-detail-value">{ mlsFormatDetail( member.SourceMemberId ) }</span>
                    </li>
                    <li className="mls-listing-agent-group-mlsid">
                        <span className="mls-detail-label">Listing Office MLS ID</span>
                        <span className="mls-detail-value">{ mlsFormatDetail( listing.OfficeId ) }</span>
                    </li>
                </ul>
                { /*member.AccountEmail && 
                    <RenderForm 
                        formID={ 14381 } 
                        panelID="" 
                        hiddenValues={ { 
                            'listing-id': listingID,
                            'listing-url': window.homeURL + '/listing/' + listingID,
                            'agent-email': member.AccountEmail,
                        } } />
                */}
            </div>
            : null }
            <div className="mls-listing-section mls-copyright-section">
                <p>&copy; { copyrightYear }, NYStateMLS, My State MLS. All rights reserved. Information is deemed reliable but not guaranteed.</p>
            </div>
            </>
        );
    } else {
        return null;
    }
}
export default Listing;

